import React from 'react';
import { IntegrationSettings } from '../types/integration_settings/integrationSettings';

export interface IntegrationSettingsContextProps {
  integrationSettings: Map<string, IntegrationSettings>;
  setIntegrationSettings: (integrationSettings: Map<string, IntegrationSettings>) => void;
  integrationSettingsLoading: boolean;
}

const defaultContext: IntegrationSettingsContextProps = {
  integrationSettings: new Map(),
  setIntegrationSettings: () => {},
  integrationSettingsLoading: false,
};

export const IntegrationContext = React.createContext<IntegrationSettingsContextProps>(defaultContext);
